var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRrAngleSmallRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3998 9.88L10.8098 5.29C10.6224 5.10375 10.369 4.99921 10.1048 4.99921C9.84062 4.99921 9.58716 5.10375 9.3998 5.29C9.30607 5.38296 9.23168 5.49356 9.18091 5.61542C9.13014 5.73728 9.104 5.86799 9.104 6C9.104 6.13201 9.13014 6.26272 9.18091 6.38458C9.23168 6.50644 9.30607 6.61704 9.3998 6.71L13.9998 11.29C14.0935 11.383 14.1679 11.4936 14.2187 11.6154C14.2695 11.7373 14.2956 11.868 14.2956 12C14.2956 12.132 14.2695 12.2627 14.2187 12.3846C14.1679 12.5064 14.0935 12.617 13.9998 12.71L9.3998 17.29C9.2115 17.477 9.10518 17.7311 9.10425 17.9965C9.10331 18.2618 9.20783 18.5167 9.3948 18.705C9.58178 18.8933 9.8359 18.9996 10.1013 19.0006C10.3666 19.0015 10.6215 18.897 10.8098 18.71L15.3998 14.12C15.9616 13.5575 16.2772 12.795 16.2772 12C16.2772 11.205 15.9616 10.4425 15.3998 9.88Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrAngleSmallRight);
export default __webpack_public_path__ + "static/media/fi-rr-angle-small-right.caf67f64cc76e41980b22f8f873e51b6.svg";
export { ForwardRef as ReactComponent };